/* eslint-disable react/no-danger */
import React from 'react';
import { Helmet } from 'react-helmet';

// eslint-disable-next-line no-undef
const GTM_ID = process.env.REACT_APP_GTM_ID;

const GoogleAnalytics: React.FC = () => {
  if (!GTM_ID) return null;
  return (
    <Helmet>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${GTM_ID}`}
      />
      <script>
        {`
          window.dataLayer = window.dataLayer || [];

          function gtag() {
            dataLayer.push(arguments);
          }

          gtag('js', new Date());
          gtag('config', '${GTM_ID}');
        `}
      </script>
    </Helmet>
  );
};

export default GoogleAnalytics;
